import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type AffiliateCTAProps = {
  label: string;
  href: string;
  variant?: 'solid' | 'outline';
  className?: string;
};
const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl px-8 py-4 text-[13px] font-bold uppercase tracking-[0.16em] transition-[transform,background-color,border-color,color] duration-200 ease-elite';
const styles = {
  solid: 'bg-accent text-accent-ink shadow-[0_18px_44px_-24px_rgb(var(--accent)/0.85)] hover:-translate-y-0.5 hover:brightness-110',
  outline: 'border border-accent/40 text-bone hover:border-accent hover:bg-accent-deep/40 hover:-translate-y-0.5'
};
export function AffiliateCTA({
  label,
  href,
  variant = 'solid',
  className = ''
}: AffiliateCTAProps) {
  const classes = `${base} ${styles[variant]} ${className}`;
  const content = <>
      <span data-id="element-14" data-mp="3lfvss2szgjav">{label}</span>
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-elite group-hover:translate-x-1" aria-hidden="true" data-id="element-15" data-mp="3qcm82nwyrav8" />
    </>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer sponsored" className={classes} data-id="element-16" data-mp="r9jni6ak2xd">
        {content}
      </a>;
  }
  return <button type="button" className={classes} data-id="element-17" data-mp="epppl6wbxpeg">
      {content}
    </button>;
}